/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionVatReviewAdminData
 */
export interface SubscriptionVatReviewAdminData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    subscriptionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    packageCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionVatReviewAdminData
     */
    netAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionVatReviewAdminData
     */
    verificationOutcome?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionVatReviewAdminData
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the SubscriptionVatReviewAdminData interface.
 */
export function instanceOfSubscriptionVatReviewAdminData(value: object): value is SubscriptionVatReviewAdminData {
    return true;
}

export function SubscriptionVatReviewAdminDataFromJSON(json: any): SubscriptionVatReviewAdminData {
    return SubscriptionVatReviewAdminDataFromJSONTyped(json, false);
}

export function SubscriptionVatReviewAdminDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionVatReviewAdminData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'subscriptionId': json['subscriptionId'] === undefined ? undefined : json['subscriptionId'] === null ? null : json['subscriptionId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'packageCode': json['packageCode'] === undefined ? undefined : json['packageCode'] === null ? null : json['packageCode'],
        'netAmount': json['netAmount'] === undefined ? undefined : json['netAmount'] === null ? null : json['netAmount'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'verificationOutcome': json['verificationOutcome'] == null ? undefined : json['verificationOutcome'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function SubscriptionVatReviewAdminDataToJSON(json: any): SubscriptionVatReviewAdminData {
    return SubscriptionVatReviewAdminDataToJSONTyped(json, false);
}

export function SubscriptionVatReviewAdminDataToJSONTyped(value?: SubscriptionVatReviewAdminData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'subscriptionId': value['subscriptionId'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'packageCode': value['packageCode'],
        'netAmount': value['netAmount'],
        'currencyCode': value['currencyCode'],
        'countryCode': value['countryCode'],
        'vatNumber': value['vatNumber'],
        'verificationOutcome': value['verificationOutcome'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

